import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CloseDialogHandler,
  DataGrid,
  DataGridColumnDefinition,
  Dialog,
  StylizedNumber,
} from 'components';
import { IntervalCommission } from 'types';

type Props = {
  open: boolean;
  intervalCommissions?: IntervalCommission[];
  onClose: CloseDialogHandler;
};

export const IntervalCommissionsInfoDialog: React.FC<Props> = ({
  open,
  intervalCommissions = [],
  onClose,
}) => {
  const { t } = useTranslation();

  const columns = useMemo(
    (): DataGridColumnDefinition<IntervalCommission>[] => [
      {
        header: t('common.amount'),
        valueGetter: (item) => `${item.min} - ${item.max}`,
      },
      {
        header: t('features.commission.commission'),
        valueGetter: (item) => (
          <StylizedNumber value={item.commission} unit="%" />
        ),
      },
    ],
    [t],
  );

  return (
    <Dialog
      open={open}
      title={t('features.commission.configuration')}
      onClose={onClose}
      modal
    >
      <DataGrid columns={columns} data={intervalCommissions} />
    </Dialog>
  );
};
